import { FC, ReactNode } from "react";
import { Box, MenuItem, MenuItemProps, Typography } from "@mui/material";

export type AppMenuItemProps = MenuItemProps & {
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  text: string;
};

const AppMenuItem: FC<AppMenuItemProps> = props => {
  const { startIcon, endIcon, text, sx, ...otherProps } = props;
  const menuItemSx = {
    py: 1,
    ...sx,
  };

  return (
    <MenuItem sx={menuItemSx} {...otherProps}>
      {startIcon}
      <Typography pl={1} variant="inherit" whiteSpace={"pre-wrap"}>
        {text}
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      {endIcon}
    </MenuItem>
  );
};

export default AppMenuItem;
